<template>
  <b-row>
    <b-col xl="8" sm="7">
        <!-- <definicion-compras :origin-id="$route.params.id" /> -->
        <b-card header="Elementos" no-body>
            <spinner v-if="loading"/>
            <b-table v-else responsive :fields="fields" :items="elementos">
                <template #cell(elemento)="data">
                    <strong>{{data.item.elemento}}</strong>
                    <br/><i>({{data.item.presentacion}} {{data.item.unidadmedicion}})</i>
                </template>
                <template #cell(marca)="data">
                    <strong>{{data.value}}</strong>
                </template>
                <template #cell(cantidad)="data">
                    <strong>{{data.value}}</strong>
                    <template v-if="!!data.item.inventario">
                        <br> <small>Existencia actual: {{data.item.inventario}}</small>
                    </template>
                </template>
                <template #cell(costo)="data">
                    <strong>{{data.value | currency}}</strong>
                </template>
                <template #cell(precio)="data">
                    <strong>{{data.value | currency}}</strong> 
                    <template v-if="!!data.item.presentacion_precio">
                        <br> <small>Precio actual de venta {{data.item.presentacion_precio | currency}}</small>
                    </template>
                </template>
            </b-table>
        </b-card>
    </b-col>
    <b-col xl="4" sm="5">
        <auto-form title="Cabecera de factura" :origin-id="$route.params.id" origin="facturas/handler" />
    </b-col>
  </b-row>
</template>

<script>
    import axios from 'axios'

    // import definicionCompras from './DefinicionCompras.vue'
    export default {
        components: {
        // definicionCompras
        },
        data: () => {
            return {
                loading: true,
                elementos: [],
                fields: [
                    {
                        key: 'elemento',
                        label: 'Artículo',
                        sortable: true
                    },
                    {
                        key: 'marca',
                        sortable: true
                    },
                    {
                        key: 'precio',
                        sortable: true,
                        label: 'Precio unitario'
                    },
                    {
                        key: 'cantidad',
                        sortable: true
                    },
                    {
                        key: 'costo',
                        sortable: true,
                        label: 'Subtotal'
                    }
                ]
            }
        },
        methods: {
            loadUpRefresh() {
                let url = 'facturas/getdetail/' + this.$route.params.id
                axios.get(url)
                    .then((response) => {
                        console.log("response", response)
                        if(response.status){
                            this.loading = false
                            this.elementos = response.data
                        }
                    })
            }
        },
        mounted(){
            this.loadUpRefresh()
        }
    }
</script>
